export default __webpack_public_path__ + "static/melt-5a5f79b705d3c2e35578453ddf3b4daf.png";